module.exports = __webpack_public_path__ + "img/RunningDead_1920x1080.8c5bbc86.png";